<div class="jbm-modal-header">
   <div class="jbm-crud-title">
      <div class="title">{{'customers.join-duplicate'|translate}}</div>
   </div>
   <div class="toolbar float-end">
      <jbm-cross-close-button (onClick)="close()"></jbm-cross-close-button>
   </div>
</div>
<div class="jbm-modal-body">
   <div>
      {{'ui.primary'|translate}} {{'entity.customer'|translate}}:&nbsp;&nbsp;<span class="fw-500">{{customerName}}</span>
   </div>
   <div class="fw-500 mt-3">{{'customers.select-duplicate'|translate}}</div>
   <div class="toolbar float-end">
      <jbm-pagination [itemCount]="queryHttpHelper.paginationProps.itemCount"
        [pageSize]="queryHttpHelper.paginationProps.pageSize"
        [page]="queryHttpHelper.paginationProps.page" (pageClick)="pageChange($event)">
      </jbm-pagination>
      <jbm-searchbox [search]="queryHttpHelper.getSearchValue()"
        [minlength]="3" (searchChange)="searchChange($event)" [id]="'customer-search'">
      </jbm-searchbox>
   </div>
   <jbm-table
     [data]="customers"
     [sortColumn]="queryHttpHelper.sortProps.name"
     [sortDirection]="queryHttpHelper.sortProps.direction"
     [hoverable]="true"
     [hideHeader]="true"
     [rowSelectable]="true"
     [selectedRowId]="duplicate_id"
     [columnDefs]="columnDefs"
     (rowSelect)="selectDuplicate($event)">
   </jbm-table>
   <ngb-alert *ngIf="duplicate_id!=-1" [type]="'warning'" [dismissible]="false" [class]="'mt-3 mb-0'">
      {{'customers.join-duplicate-info-1'|translate}}: {{'financial.pricelists'|translate}},
      {{'entity.quotations'|translate}}, {{'entity.projects'|translate}} {{'ui.and'|translate}} {{'entity.invoices'|translate}}.
      <br />
      {{'customers.join-duplicate-info-2'|translate}}.
      {{'ui.action-without-undo'|translate}}.
   </ngb-alert>
</div>
<div class="jbm-modal-footer">
   <div class="toolbar float-end">
      <button type="button" class="btn btn-success btn-sm mr-2" [disabled]="duplicate_id==-1" (click)="join()">{{'customers.join-duplicate'|translate}}</button>
      <jbm-cancel-button (click)="close()"></jbm-cancel-button>
   </div>
</div>
